import React, { Component } from "react"
import PropTypes from "prop-types"

import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { 
  Grid, Col, PageHeader, Well, Glyphicon, ListGroup, //ListGroupItem,
  Form, FormGroup, ControlLabel, FormControl, Button, Checkbox
} from "react-bootstrap"
import DatePicker from "react-bootstrap-date-picker"

import { Map, fromJS } from "immutable"
import uuidv4 from "uuid/v4"
import moment from "moment-timezone"
import "moment/locale/id"

import * as actionCreators from "../actions"
import { processInt } from "./Common"
import OrderDetailForm from "./OrderDetailForm"

moment.tz.setDefault("Asia/Jakarta")

const newOrder = fromJS({
  orderNo: "",
  dealerName: "",
  customerName: "",
  customerPhone1: "",
  customerAddress: "",
  details: {}
})

class OrderNew extends Component {
  static propTypes = {
    order: PropTypes.object,
    actions: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired
  }

  state = {
    isEdited: false,
    edited: fromJS({ orderDate: moment().format() })
  }

  componentDidMount() {
    this.handleDetailAdd()    
  }

  handleSubmit = e => {
    e.preventDefault()

    const { edited } = this.state
    let errors = ""

    // Check mandatory fields
    if (!edited.get("orderNo"))
      errors = (errors.length > 0 ? "\n" : "") + "Order No. cannot be empty!"
    else if (this.props.orders.filter((item, key) => (item.get("orderNo") === edited.get("orderNo"))).size > 0)
      errors = (errors.length > 0 ? "\n" : "") + "Order No. already exists!"

    if (!edited.get("orderDate"))
      errors = (errors.length > 0 ? "\n" : "") + "Order Date cannot be empty!"
    if (!edited.get("dealerUuid"))
      errors = (errors.length > 0 ? "\n" : "") + "Need to select dealer!"
    if (!edited.get("customerName"))
      errors = (errors.length > 0 ? "\n" : "") + "Customer Name cannot be empty!"
    
    // check on details
    if (!edited.get("details").size === 0)
      errors = (errors.length > 0 ? "\n" : "") + "Item cannot be empty!"
    else
      edited.get("details").valueSeq().forEach(detail => {
        if (!detail.get("productName"))
          errors = (errors.length > 0 ? "\n" : "") + "Product Name cannot be empty!"
        if (!detail.get("orderQuantity"))
          errors = (errors.length > 0 ? "\n" : "") + "Quantity cannot be empty!"
        if (!detail.get("purchasePrice"))
          errors = (errors.length > 0 ? "\n" : "") + "Purchase Price cannot be empty!"
      })

    if (errors) {
      alert(errors)
      return
    }

    this.props.actions.createOrder(edited)
    this.props.history.push("/orders")    
  }

  handleClose = e => {
    if (!this.state.isEdited || window.confirm("Are you sure you want to close?")) {
      this.props.history.push("/orders")
    }
  }

  handleChange = e => {
    const { name } = e.target
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;

    this.setState((prev, props) => ({
      isEdited: true,
      edited: prev.edited.set(name, value)
    }))
  }

  recalculateAmounts = () => {
    this.setState((prev, props) => {
      let edited = prev.edited

      // Recalculate purchaseAmount & salesAmount
      let purchaseAmount = 0
      edited.get("details").forEach((detail, key) => {
        purchaseAmount += detail.get("orderQuantity") * detail.get("purchasePrice")
      })
      edited = edited.merge({ purchaseAmount })

      return { edited }
    })
  }

  handleDetailChange = e => {
    const { id, name } = e.target
    let { value } = e.target

    this.setState((prev, props) => {
      let edited = prev.edited
      
      // Check if value should be integer
      if (["orderQuantity", "purchasePrice"].indexOf(name) !== -1)
        value = processInt(value)

      edited = edited.setIn(["details", id, name], value)
      
      return { isEdited: true, edited }
    }, () => this.recalculateAmounts())
  }

  handleDetailAdd = () => {
    console.log("handleDetailAdd called.")
    const uuid = `_new_${uuidv4()}`

    this.setState((prev, props) => ({
      edited: prev.edited.setIn(["details", uuid], fromJS({ uuid }))
    }))
  }

  handleDetailDelete = e => {
    const { id } = e.target

    if (window.confirm("Are you sure you want to delete this item?")) {
      this.setState((prev, props) => {
        let edited = prev.edited
  
        if (edited.get("details").size > 1)
          edited = edited.deleteIn(["details", id])
        else
          edited = edited.setIn(["details", id], fromJS({ uuid: id }))
  
        return { edited }
      }, () => this.recalculateAmounts())
    }
  }

  handleOrderDateChange = (value, formattedValue) => {
    this.setState((prev, props) => ({
      edited: prev.edited.set(
        "orderDate",
        moment(value).format()
      )
    }))
  }

  getValue = (name, isDate = false) => {
    let value = this.state.edited.get(name) || (this.props.order && this.props.order.get(name)) || ""
    return (isDate ? (value ? moment(value).format() : moment().format()) : value)
  }

  getDetailValue = (name, detailObject, detailId) => {
    return (this.state.edited && this.state.edited.getIn([detailObject, detailId, name])) || 
      (this.props.order && this.props.order.getIn([detailObject, detailId, name])) || ""
  }

  render() {
    return (
      <Form horizontal onSubmit={this.handleSubmit}>
        <Grid>

          <PageHeader>Order {this.getValue("orderNo")}</PageHeader>

          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>No. Pesanan</Col>
            <Col sm={4}>
              <FormControl
                name="orderNo"
                placeholder="No. Pesanan"
                value={this.getValue("orderNo")}
                onChange={this.handleChange} />
            </Col>
            <Col componentClass={ControlLabel} sm={2}>Tanggal Pesanan</Col>
            <Col sm={4}>
              <DatePicker name="orderDate" placeholder="Tanggal Pesanan" showClearButton={false}
                value={this.getValue("orderDate", true)}
                onChange={this.handleOrderDateChange} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Nama Dealer</Col>
            <Col sm={8}>
                <FormControl
                componentClass="select"
                name="dealerUuid"
                placeholder="Nama Dealer"
                value={this.getValue("dealerUuid")}
                onChange={this.handleChange}>
                  <option></option>
                  {this.props.dealers.valueSeq().map(d =>
                    <option key={d.get("uuid")} value={d.get("uuid")}>{d.get("dealerName")}</option>
                  )}
              </FormControl> 
            </Col>
            <Col sm={2}>
              <Checkbox name="isSelfDelivery"
                checked={this.getValue("isSelfDelivery")}
                onChange={this.handleChange}>
                Self Delivery
              </Checkbox>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Nama Customer</Col>
            <Col sm={4}>
              <FormControl
                name="customerName"
                placeholder="Nama Customer"
                value={this.getValue("customerName")}
                onChange={this.handleChange} />
            </Col>
            <Col componentClass={ControlLabel} sm={2}>Telepon Customer</Col>
            <Col sm={4}>
              <FormControl
                name="customerPhone1"
                placeholder="Telepon Customer"
                value={this.getValue("customerPhone1")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Alamat Customer</Col>
            <Col sm={10}>
              <FormControl
                componentClass="textarea"
                rows="5"
                name="customerAddress"
                placeholder="Alamat Customer"
                value={this.getValue("customerAddress")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          
          <ListGroup>
            {this.state.edited.get("details") && this.state.edited.get("details").keySeq().map(key => (
              <OrderDetailForm key={key}
                detailId={key}
                getValue={this.getDetailValue}
                handleChange={this.handleDetailChange}
                handleDelete={this.handleDetailDelete} />
            ))}
          </ListGroup>

          <Well bsSize="small">
            <Button bsSize="small" bsStyle="danger" onClick={this.handleClose}>
              <Glyphicon glyph="list" /> Close
            </Button>

            <span className="pull-right">
              <Button bsSize="small" bsStyle="info" onClick={this.handleDetailAdd}>
                <Glyphicon glyph="plus" /> Add Item
              </Button>
              &nbsp;
              <Button bsSize="small" bsStyle="primary" onClick={this.handleSubmit}>
                <Glyphicon glyph="save" /> Submit Order
              </Button>
            </span>
          </Well>

        </Grid>
      </Form>
    )
  }
} 

const mapStateToProps = (state, ownProps) => ({
  dealers: state.get("dealers") || Map(),
  orders: state.get("orders") || Map(),
  order: newOrder
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch)
})

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderNew))



// WEBPACK FOOTER //
// ./src/components/OrderNew.js